module.exports = __webpack_public_path__ + "static/media/noimage.dd7b10ec.svg";